import { mapState } from 'vuex'

export default {
	computed: {
        ...mapState(['userTeam']),
		isTeamOwner () {
			return this.userTeam.teamRole === 'OWNER'
		},
		isTeamAdmin () {
			return this.userTeam.teamRole === 'ADMIN'
		},
		isTeamEditor () {
			return this.userTeam.teamRole === 'EDITOR'
		},
		isTeamViewer () {
			return this.userTeam.teamRole === 'VIEWER'
		}
	}
}
